import React, { useState } from 'react'
import styled from 'styled-components'

import { getLicensePlan } from 'utils/licensesUtils'

import { getEulaUrl } from 'containers/EULAModal/constants'

import Button from 'components/lib/DesignSystem/Button'
import Checkbox from 'components/lib/DesignSystem/Checkbox'
import OldModal from 'components/lib/OldModal'
import { onTablet } from 'components/styles/utils/breakpoints'

import ErrorContainer from '../ErrorContainer'

const Header = styled(({ className, error }) => (
  <header className={className}>
    {error ? <ErrorContainer error={error} /> : null}
    <h2>Congratulations!</h2>
  </header>
))`
  h2 {
    color: var(--ds-gray-1);
    font-weight: var(--semibold);
    font-size: var(--main-text);
    margin: 0;
  }
`
const Content = styled(({ className, plan, checked = false, onChange, eulaType }) => (
  <main className={className}>
    <img
      height="115px"
      width="130px"
      src={`${STATIC_BASE_URL}/static/webapp/images/congratulation.png`}
    />
    <div className="eula_checkbox">
      <p>
        <h3>
          Your license has been upgraded to <b style={{ textTransform: 'capitalize' }}>{plan}</b>!
        </h3>
      </p>
      <Checkbox
        onChange={onChange}
        name="eula"
        checked={checked}
        label={
          <div>
            I hereby agree and consent to the{' '}
            <a
              id="Eula_Modal_User_Agreement"
              href={getEulaUrl(eulaType)}
              target="_blank"
              rel="noopener noreferrer"
            >
              User Agreement
            </a>
            , its policies, and the{' '}
            <a
              id="Eula_Modal_Privacy_Policy"
              href="https://ironscales.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        }
        id="Eula_Modal_Eula_Checkbox"
      />
    </div>
  </main>
))`
  display: flex;
  gap: 30px;

  ${onTablet()} {
    flex-direction: column;
    align-items: center;
  }
  h3 {
    font-weight: var(--regular);
    font-size: var(--paragraph-text);
  }
  .eula_checkbox {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    ${onTablet()} {
      gap: 16px;
    }
  }
`

const Footer = styled(({ className, isValid = false, onClick, loader }) => (
  <footer className={className}>
    <Button
      text="Save"
      disabled={!isValid}
      id="EULA_Modal_Save_Button"
      onClick={onClick}
      loader={loader}
    />
  </footer>
))`
  margin: 0;
  display: flex;
  gap: 30px;
  justify-content: flex-end;
  h3 {
    font-weight: var(--regular);
    font-size: var(--body-text);
  }
`

function EULAModal({
  submitEULA,
  licenses,
  loader,
  error,
  className,
  showEula,
  eulaType,
  isFirstLogin,
}) {
  const [isValid, setIsValid] = useState(false)
  const toggleValid = () => {
    setIsValid((prevValid) => !prevValid)
  }
  const license = getLicensePlan(licenses)
  if (isFirstLogin) return null
  if (!showEula) return null

  return (
    <OldModal width="616px">
      <div className={className} id="EULA_MODAL">
        <Header error={error} />
        <Content onChange={toggleValid} checked={isValid} plan={license} eulaType={eulaType} />
        <Footer
          isValid={isValid}
          onClick={() => submitEULA(eulaType, getEulaUrl(eulaType))}
          loader={loader}
        />
      </div>
    </OldModal>
  )
}

export default styled(EULAModal)`
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`
